(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    

window.onload = function() {
    let test = document.querySelector('.main-page__nav__item.active');
    var myElement = test;
    var myContainer = document.querySelector('.main-page__nav')
    var elementRect = myElement.getBoundingClientRect();
    var containerRect = myContainer.getBoundingClientRect();
    var scrollLeft = elementRect.left - containerRect.left + myContainer.scrollLeft;
    myContainer.scrollLeft = scrollLeft;
  };
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-collab"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product__recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-ti"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product__recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-wf"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product__recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product__recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();
})();
